var freeShippingThreshold = parseInt(document.querySelector('#free-shipping-threshold').innerHTML);

// Set target value for free shipping
var setShippingBarPrice = () => {
    // Set variables to update elements
    var cartTotalElement = document.querySelector('#CartTotal span');
    var cartTotal = Number(cartTotalElement.innerHTML.replace(/[^0-9\.-]+/g,"")).toFixed(2);
    var shippingBarText = document.querySelector('.shipping-bar-text');
    var shippingBar = document.querySelector('.shipping-bar');
    var cartShippingBar = document.querySelector('.shipping-bar-cart');
    var cartInfoBanner = document.querySelector('.cart-info-banner');

    // Grab Liquid variables from HTML for use here
    var shippingAboveThreshold = document.querySelector('#free-shipping-above').innerText;
    var shippingBelowThreshold = document.querySelector('#free-shipping-below').innerText;
    var shippingEmpty = document.querySelector('#free-shipping-empty').innerText;
    var shippingBoldText = document.querySelector('#free-shipping-bold').innerText;

    // Check for ineligible items in cart and hide bar if found
    if (hasIneligibleItems()) {
        if (cartShippingBar) {
            cartShippingBar.style.display = 'none';
            cartInfoBanner.style.display = 'none';
        }

        shippingBar.style.display = 'none';
    } else {
        shippingBar.style.display = 'block';

        if (cartInfoBanner) {
            cartInfoBanner.style.display = 'block';
        }

        if (cartTotal >= freeShippingThreshold) {
            var newText = shippingAboveThreshold.replace('xxx', `<span id='shipping-bar-price'>${shippingBoldText}</span>`)
    
            shippingBarText.innerHTML = newText;
            
        } else if (cartTotal < 0.01) {
            var newText = shippingEmpty.replace('xxx', `<span id='shipping-bar-price'>£${freeShippingThreshold}</span>`)
    
            shippingBarText.innerHTML = newText;
    
        } else {
            var difference = freeShippingThreshold - cartTotal;
            var newText = shippingBelowThreshold.replace('xxx', `<span id='shipping-bar-price'>£${difference.toFixed(2)}</span>`)
    
            shippingBarText.innerHTML = newText;
        }
    
        setBarProgress(cartTotal);
    }
}

// Set progress bar depending on basket value
var setBarProgress = (price) => {
    var shippingBarProgress = document.querySelector('.shipping-bar-progress');
    var thresholdQuarter = freeShippingThreshold / 4;
    var barWidth;
    
    if (price < 0.01) {
        barWidth = '0'
    } else if (price <= thresholdQuarter) {
        barWidth = '20%'
    } else if (price <= thresholdQuarter * 2) {
        barWidth = '40%'
    } else if (price <= thresholdQuarter * 3) {
        barWidth = '60%'
    } else if (price < thresholdQuarter * 4) {
        barWidth = '80%'
    } else {
        barWidth = '100%'
    }

    shippingBarProgress.style.width = barWidth;
}

// Hide the bar if heavy item is detected in cart items
var hasIneligibleItems = () => {
    var cartItems = document.querySelectorAll('.cart-item');

    for (var cartItem of cartItems) {
        if (cartItem.hasAttribute('data-ineligible-free-ship')) {
            return true;
        }
    }

    return false;
}

// Watch for price changes
var watchPriceChanges = () => {
    var targetNode = document.querySelector('#AjaxCartSubtotal');
    var options = {
        characterData: true,
        childList: true
    }

    var observerCallback = (mutationList, observer) => {
        mutationList.forEach((mutation) => {
            if (mutation.type === "childList") {
                setShippingBarPrice();
            }
        })
    }

    var observer = new MutationObserver(observerCallback);
    observer.observe(targetNode, options);
}

document.addEventListener('DOMContentLoaded', () => {
    // Initial setup call
    setShippingBarPrice();
    watchPriceChanges();
})